import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface DeleteCaseModalProps {
  caseRef: string;
  handleDeleteCase: () => void;
  isPending: boolean;
  onClose: () => void;
}

export default function DeleteCaseModal({
  caseRef,
  handleDeleteCase,
  isPending,
  onClose,
}: DeleteCaseModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Delete Case">
      <div className={s.modalForm}>
        <p style={{ color: 'var(--danger-600, #dc2626)', fontWeight: 600 }}>
          Are you sure you want to permanently delete case <strong>{caseRef}</strong>?
        </p>
        <p>
          This will remove the case and all related records (notes, tasks, timesheet entries, etc.).
          This action cannot be undone.
        </p>
        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button
            className={s.btnPrimary}
            style={{ backgroundColor: 'var(--danger-600, #dc2626)' }}
            onClick={handleDeleteCase}
            disabled={isPending}
          >
            {isPending ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faTrash} />
            )}{' '}
            Delete Case
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
